import { render, staticRenderFns } from "./HeaderButton.vue?vue&type=template&id=afff6cfc&scoped=true&"
import script from "./HeaderButton.vue?vue&type=script&lang=js&"
export * from "./HeaderButton.vue?vue&type=script&lang=js&"
import style0 from "./HeaderButton.vue?vue&type=style&index=0&id=afff6cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afff6cfc",
  null
  
)

export default component.exports